import { createRoutes as createDealerRoutes } from './Dealer/router'
import { createRoutes as createSellerRoutes } from './Seller/router'

export function createRoutes() {
  return [
    ...createDealerRoutes(),
    ...createSellerRoutes(),
  ]
}
